import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgCheckSquare = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22.28 0H1.72A1.77 1.77 0 0 0 0 1.72v20.56A2.64 2.64 0 0 0 1.72 24h20.56A1.77 1.77 0 0 0 24 22.28V1.72A1.77 1.77 0 0 0 22.28 0m-1 21.33H2.67V2.67h18.66ZM9.05 17.68a2 2 0 0 0 .48.45 2.15 2.15 0 0 0 3-.49l.06-.07 6.93-9.72a1 1 0 0 0-.24-1.41 1 1 0 0 0-1.24 0l-7.44 6.39-4.43-3a1.23 1.23 0 0 0-1.72.3 1.25 1.25 0 0 0 0 1.46Z"
    }));
export default SvgCheckSquare;
